import React from 'react';
import { ModalButtonProps } from '../../../../../../../components/modal/modal.interfaces';
import ModalComponent from '../../../../../../../components/modal/modalComponent';

interface ShowOnMapModalProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  address: string;
}

const ShowOnMapModal: React.FC<ShowOnMapModalProps> = ({
  setIsOpen,
  isOpen,
  address,
}) => {
  const onSubmit = () => {
    const encodedAddress = encodeURIComponent(address);
    setIsOpen(false);
    const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
    window.open(googleMapsUrl, '_blank');
  };
  const Buttons: ModalButtonProps[] = [
    {
      label: 'Find on map',
      onClick: onSubmit,
      testID: 'find',
    },
    {
      label: 'Close',
      type: 'underline',
      onClick: () => setIsOpen(false),
      testID: 'close',
    },
  ];
  return (
    <ModalComponent
      title="Show on map?"
      isOpen={isOpen}
      modalContainerCustomClass="max-w-[600px]"
      onClose={() => setIsOpen(false)}
      buttons={Buttons}
    >
      <p>{address}</p>
    </ModalComponent>
  );
};

export default ShowOnMapModal;
